function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Heading } from '../Heading';
import { Text } from '../Text';
import styles from '@dtsl/css-collapsible-section/dist/index.module.css';
import ChevronUp from '@dtsl/icons/dist/icons/react/ChevronUp';
import { onCollapsable } from '@dtsl/react/dist/components/Utils/collapsible';
import '@dtsl/css-dropdown/dist/collapsible.css';
function CollapsibleSection(props) {
  const {
    label,
    variant,
    children,
    disabled,
    defaultOpen,
    className,
    id,
    headingMetaData,
    textMetaData
  } = props;
  const [isOpen, setIsOpen] = React.useState(disabled ? false : defaultOpen);
  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);
  const collapsibleSectionClasses = classNames({
    [`sib-collapsible ${styles['sib-collapsible-section']}`]: true,
    [styles['disabled']]: disabled,
    [className]: !!className
  });
  const triggerClasses = classNames({
    [styles['sib-collapsible-section-header']]: true,
    [styles[`sib-collapsible-section-header-${variant}`]]: true,
    'sib-collapsible__trigger': true,
    'sib-collapsible__trigger_toggled': isOpen
  });
  const contentClasses = classNames({
    [styles['sib-collapsible-section-content']]: true,
    'sib-collapsible__content': true,
    'sib-collapsible__content_toggled': isOpen
  });
  const getHeaderData = () => {
    return /*#__PURE__*/React.createElement("button", {
      tabIndex: "0",
      disabled: disabled,
      onClick: e => {
        onCollapsable(e);
        setIsOpen(!isOpen);
      },
      className: triggerClasses,
      "aria-controls": id,
      "aria-expanded": isOpen ? 'true' : 'false'
    }, /*#__PURE__*/React.createElement("span", {
      className: styles['sib-collapsible-section-label']
    }, label), /*#__PURE__*/React.createElement("span", {
      className: styles['sib-collapsible-section-arrowicon']
    }, /*#__PURE__*/React.createElement(ChevronUp, {
      className: "sib-dropdown-option-group-marker"
    })));
  };
  const getHeaderVariant = variant => {
    switch (variant) {
      case 'heading':
        return /*#__PURE__*/React.createElement(Heading, headingMetaData, getHeaderData());
      case 'text':
        return /*#__PURE__*/React.createElement(Text, _extends({
          tag: "div"
        }, textMetaData), getHeaderData());
      case 'link':
        return getHeaderData();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: collapsibleSectionClasses
  }, getHeaderVariant(variant), /*#__PURE__*/React.createElement("div", {
    className: contentClasses,
    "data-collapsible-behavior": "shutter",
    "data-speed-divisor": "2",
    id: id,
    "aria-hidden": isOpen ? 'false' : 'true'
  }, children));
}
CollapsibleSection.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  variant: PropTypes.string,
  headingMetaData: PropTypes.object,
  textMetaData: PropTypes.object
};
CollapsibleSection.defaultProps = {
  className: '',
  label: 'Default',
  disabled: false,
  defaultOpen: false,
  id: 'collapsible-section-id',
  headingMetaData: {},
  textMetaData: {},
  variant: 'link'
};
export default CollapsibleSection;